export default "/assets/images/the-mama-to-be.af35b353fe47cc35.jpg";